import React from "react";
export const AuthContext = React.createContext({
  appStates: {},
  emailExist: { error: "", email: "" },
  toSignUp: false,
  userData: {},
  onSignUp: () => {},
  onLogin: () => {},
  onLogout: () => {},
  onRegister: () => {},
  onSaveUserData: () => {},
  onSaveLoginState: () => {},
  onSaveRegisterState: () => {},
  loginReplyStates: {
    isLoading: false,
    error: false,
    reply: "",
  },
  registerReplyStates: {
    isLoading: false,
    error: false,
    reply: "",
  },
  onSaveEmailExist: () => {},
});
